// src/layouts/WebLayout.jsx

import WebHeader from './components/WebHeader';
import WebFooter from './components/WebFooter';
import { Outlet } from 'react-router-dom';
import LanguageSetter from '../locales/LanguageSetter';

export default function WebLayout() {
  return (
    <div className="web-layout">
      <LanguageSetter />
      <WebHeader />
      <div className="flex-container">
        <main className="main-content">
         
            <Outlet />
          
        </main>
      </div>
      <WebFooter />
    </div>
  );
}